import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactModal from 'react-modal';

import './index.css';
import './libs';
import App from './App/App';

// tslint:disable-next-line:no-var-requires
require('url-search-params-polyfill');
// tslint:disable-next-line:no-var-requires
require('array.prototype.find').shim();
// tslint:disable-next-line:no-var-requires
require('string.prototype.startswith');

// tslint:disable-next-line:only-arrow-functions
Math.trunc = Math.trunc || function(x) {
    if (isNaN(x)) {
      return NaN;
    }
    if (x > 0) {
      return Math.floor(x);
    }
    return Math.ceil(x);
};

if (!Date.now) {
  Date.now = function now() {
    return new Date().getTime();
  };
}

ReactModal.setAppElement('#root')

ReactDOM.render(
    <App />,
    document.getElementById('root') as HTMLElement
);



// WEBPACK FOOTER //
// ./src/index.tsx